const WEEKDAYS = [
  ["monday", "Mon"],
  ["tuesday", "Tue"],
  ["wednesday", "Wed"],
  ["thursday", "Thu"],
  ["friday", "Fri"],
  ["saturday", "Sat"],
  ["sunday", "Sun"],
];

const formatTime = (time) =>
  typeof time === "string" ? time.slice(0, 5) : time;

export function mapPlanScheduleOptions(data) {
  return (data || [])
    .filter((schedule) => schedule.active !== false)
    .map((schedule) => {
      const activeDays = WEEKDAYS.filter(([key]) => schedule[key])
        .map(([, label]) => label)
        .join(" - ");
      const timeRange =
        schedule.start_time && schedule.end_time
          ? `${formatTime(schedule.start_time)} to ${formatTime(
              schedule.end_time
            )}`
          : "";
      const description = [schedule.period, activeDays, timeRange]
        .filter(Boolean)
        .join(" - ");
      return { value: schedule.id, label: description || schedule.id };
    });
}

export default mapPlanScheduleOptions;
